import { FileUpload } from "primereact/fileupload";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const chooseOptions = { icon: "pi pi-fw pi-plus", className: "custom-choose-btn p-button-info" };
const uploadOptions = { icon: "pi pi-fw pi-upload", className: "custom-choose-btn p-button-success" };
const cancelOptions = { icon: "pi pi-fw pi-times", className: "custom-choose-btn p-button-danger" };

const headerTemplate = (options) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;

    return (
        <div className={className} style={{ backgroundColor: "#f8f9fb", display: "flex", alignItems: "center" }}>
            {chooseButton}
            {uploadButton}
            {cancelButton}
        </div>
    );
};
const itemTemplate = (file, options) => {
    return (
        <div className="detail__upload">
            <div className="name__file" style={{ width: "40%" }}>
                <span className="text">{file.name}</span>
                <span className="text">{options.formatSize}</span>
            </div>
            <ButtonUI icon="pi pi-times" rounded text severity="danger" aria-label="Cancel" onClick={() => options.onRemove()} />
        </div>
    );
};

const UploadUI = ({ handleUpload, formats = "CSV, JSON" }) => {
    return (
        <div className="upload">
            <div className="upload__header">
                <div className="title">
                    Загрузите файлы формата <span>{formats}</span>
                </div>
            </div>

            <FileUpload
                name="demo[]"
                url={"/api/upload"}
                chooseLabel="Выбрать"
                uploadLabel="Отправить"
                cancelLabel="Удалить"
                chooseOptions={chooseOptions}
                uploadOptions={uploadOptions}
                cancelOptions={cancelOptions}
                itemTemplate={itemTemplate}
                maxFileSize={10000000}
                headerTemplate={headerTemplate}
                uploadHandler={handleUpload}
                customUpload
            />
        </div>
    );
};

export default UploadUI;
